'use strict';

import appModule from '../app.module';

angular.module(appModule)
.factory('FilterState', function() {
  var P = 'otfip_f_';
  return {
    save: function(page, state) {
      try { sessionStorage.setItem(P + page, JSON.stringify(state)); } catch (e) {}
    },
    load: function(page) {
      try {
        var v = sessionStorage.getItem(P + page);
        return v ? JSON.parse(v) : {};
      } catch (e) { return {}; }
    },
    clear: function(page) {
      try { sessionStorage.removeItem(P + page); } catch (e) {}
    }
  };
});
